import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useState } from 'react';
import { Button, EmptyState, ErrorCard, Skeleton } from '@wit-support/ui';
import { describeAdsError } from '../shared.js';
/*
 * Общие части диалогов выбора раздела («Топ-посты», выбор медиа): набор
 * отмеченных, состояния списка и кнопка «Добавить (N)».
 */
/** Отмеченные элементы по ключу; порядок — порядок отметки. */
export function usePicked(keyOf) {
    const [picked, setPicked] = useState([]);
    const has = (item) => picked.some((x) => keyOf(x) === keyOf(item));
    const toggle = (item, on) => setPicked((cur) => {
        const rest = cur.filter((x) => keyOf(x) !== keyOf(item));
        return on ? [...rest, item] : rest;
    });
    const add = (item) => toggle(item, true);
    const reset = useCallback(() => setPicked([]), []);
    return { picked, has, toggle, add, reset };
}
/** Состояния списка: ошибка, загрузка, пусто — иначе сам список. */
export function PickerResults({ error, loading, empty, emptyState, children, }) {
    if (error)
        return _jsx(ErrorCard, { children: describeAdsError(error) });
    if (loading)
        return _jsx(Skeleton, { className: "h-40 w-full" });
    if (empty) {
        return (_jsx(EmptyState, { icon: emptyState.icon, title: emptyState.title, ...(emptyState.description ? { description: emptyState.description } : {}) }));
    }
    return _jsx(_Fragment, { children: children });
}
/**
 * «Добавить (N)» в подвале диалога выбора. `busy` — в окне идёт работа (загрузка
 * файла), закрывать его нельзя: тот же гард, что у крестика и «Отмены».
 */
export function AddPickedButton({ count, onClick, busy = false, }) {
    return (_jsxs(Button, { type: "button", disabled: count === 0 || busy, onClick: onClick, ...(busy ? { title: 'Дождитесь окончания загрузки' } : {}), children: ["\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C (", count, ")"] }));
}
//# sourceMappingURL=picker-parts.js.map